<div class="container-fluid">
  <div class="page-header">
    <div class="row">
      <div class="col-12">
        <div class="page-header-left">
          <h4>{{title | async}}</h4>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><h5>
                <app-feather-icons [icon]="'home'"></app-feather-icons></h5>
            </li>
            <li class="breadcrumb-item" *ngIf="breadcrumbs?.parentBreadcrumb">{{breadcrumbs?.parentBreadcrumb | async}}</li>
            <li class="breadcrumb-item active" *ngIf="breadcrumbs?.childBreadcrumb">{{breadcrumbs?.childBreadcrumb| async}}
            </li>
          </ol>
        </div>
      </div>
      <!-- <div class="col-lg-4">
        <app-bookmark></app-bookmark>
      </div> -->
    </div>
  </div>
</div>